import React, { useEffect, useState } from "react";
import { AppRouteProps } from "./AppRoute";
import { useAppSelector } from "../../app/hooks";
import { axiosInstance } from "../../api/config/axiosInstance";
import storage from "../../utils/storage/cryptoStorage";

const AuthWrapper = ({
  children,
  role,
}: {
  children: React.ReactElement;
  role?: string;
}) => {
  const { isAuthenticated, user } = useAppSelector((state) => state.auth);
  const [roles, setRoles] = useState<GetUserModuleRolesPriviliges>();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = storage.getLocalStorage("token");

    if (isAuthenticated && token) {
      axiosInstance
        .post<GetUserModuleRolesPriviliges>(
          process.env.REACT_APP_API_URL +
            "/authorization/api/User/GetUserAppPrivileges",
          {
            //userId: user?.ID,
            formName: role,
            privType: "2",
            //applicationId: 1
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((response : any) => {
          setRoles(response.data);
          setLoading(false);
        });
    }
  }, []);

  if (loading) {
    return <></>;
  } else {
    const modifiedChildren = React.cloneElement(children, {
      ...children.props,
      roles: roles?.DbResponse?.Result,
    });
    return modifiedChildren;
  }
};

export const wrapRoutes = (routes: AppRouteProps[]) => {
  return routes.map((route) => {
    return {
      ...route,
      element: <AuthWrapper role={route.role}>{route.element}</AuthWrapper>,
    };
  });
};

export default AuthWrapper;

interface GetUserModuleRolesPriviliges {
  IsSuccess: boolean | null;
  Message: string | null;
  DbResponse: DbResponse | null;
}

interface DbResponse {
  IsSuccess: boolean | null;
  Message: string | null;
  Result: Result[] | null;
}

interface Result {
  R_ID: number | null;
  KEY_VALUE: string | null;
  IS_MAIN_MENU: number | null;
  ML_ID: number | null;
  MODULE_NAME: string | null;
  MODULE_MESSAGE_ID: string | null;
  MPL_ID: number | null;
  MODULE_DETAIL_NAME: string | null;
  PL_ID: number | null;
  OG_ID: number | null;
  LINK_OBJECT_ID: number | null;
  OBJECT_NAME: string | null;
  LINE_NO: number | null;
  DESCRIPTIONS: string | null;
  UFM_ID: number | null;
  BACKGROUND_COLOR: string | null;
  MESSAGE_ID: string | null;
  WEB_URL: string | null;
  ID: number | null;
}
